import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['body']

  toggle(event) {
    const item = event.currentTarget.closest('.accordion-item')
    const body = item.querySelector('.accordion-body')

    item.classList.toggle('open')
    body.classList.toggle('open')
  }
}
